import { useLocation, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, WifiOff, Zap } from "lucide-react";
import {
  TailDashboardIcon,
  TailMessageIcon,
  TailPackageIcon,
  TailSettingsIcon,
  TailUsersIcon,
} from "@/components/template/tailadmin/TailAdminIcons";
import { cn } from "@/lib/utils";

const BRMLayout = ({ children, onLogout, isOnline }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: "/brm/dashboard", icon: TailDashboardIcon, label: "Home", testId: "nav-home" },
    { path: "/brm/enroll", icon: TailUsersIcon, label: "Enroll", testId: "nav-enroll" },
    { path: "/brm/campaigns", icon: TailPackageIcon, label: "Market", testId: "nav-marketplace" },
    { path: "/brm/messages", icon: TailMessageIcon, label: "Chat", testId: "nav-messages" },
    { path: "/brm/wallet", icon: Zap, label: "Wallet", testId: "nav-wallet" },
    { path: "/brm/profile", icon: TailSettingsIcon, label: "Profile", testId: "nav-profile" },
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-gray-50 pb-safe font-sans text-gray-800">
      {!isOnline ? (
        <div className="sticky top-0 z-50 flex h-8 items-center justify-center gap-2 bg-[#fffaeb] text-xs font-medium text-[#b54708]">
          <WifiOff className="h-3.5 w-3.5" />
          Offline mode
        </div>
      ) : null}

      <header className="sticky top-0 z-40 border-b border-gray-200 bg-white/95 px-4 py-3 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <button className="flex items-center gap-3 text-left" onClick={() => navigate("/brm/dashboard")}>
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-500 text-white shadow-theme-xs">
              <ShieldCheck className="h-5 w-5" />
            </span>
            <span>
              <span className="block text-base font-semibold text-gray-900">Proovam</span>
              <span className="block text-xs text-gray-500">BRM workspace</span>
            </span>
          </button>
          <button
            onClick={onLogout}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-[#d92d20]"
            aria-label="Logout"
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 overflow-y-auto px-4 py-5 pb-6">
        {children}
      </main>

      <nav className="z-50 shrink-0 border-t border-gray-200 bg-white/95 px-2 pb-[env(safe-area-inset-bottom,0px)] shadow-[0_-4px_12px_rgba(16,24,40,0.06)] backdrop-blur" data-testid="brm-bottom-nav">
        <div className="mx-auto flex max-w-3xl items-center justify-around py-2">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex min-h-[56px] min-w-[60px] flex-col items-center justify-center gap-1 rounded-xl px-2 text-xs font-medium transition",
                isActive(item.path)
                  ? "bg-brand-50 text-brand-500"
                  : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
              )}
              data-testid={item.testId}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default BRMLayout;
